import { render, staticRenderFns } from "./SalesInvoiceViewLogs.vue?vue&type=template&id=edd7bf6a"
import script from "./SalesInvoiceViewLogs.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports